import React from 'react';
import {useNavigate} from "react-router-dom";

const ServiceItem = ({service}) => {
    const navigate = useNavigate();
    return (
        <li onClick={() => navigate(`/admin/services/${service.id}`, {state: {service}})} className="service__item">
            <div className="d-flex align-items-center">
                <img
                    className="service__logo"
                    src={`data:image/jpg;base64,${service.imageBase64}`}
                    alt={service.imageTag}
                />
                <p className="service__title">{service.name}</p>
            </div>
        </li>
    );
};

export default ServiceItem;
